import { RootState } from '../store';
import { createSelector } from '@reduxjs/toolkit';

const profile = (state: RootState) => state.app.profile;
const waiters = (state: RootState) => state.app.config.account_waiters;

export const selectProfileWaiters = createSelector([profile, waiters], (profile, waiters) =>
  waiters.filter((waiter) => profile.waiters.includes(Number(waiter.value))),
);
